export default __webpack_public_path__ + "static/media/Switch.8c4e4399.svg";